/**
 * `223089` — *When {status} changes from {previousStatusColumnValue} to {statusColumnValue}*.
 * The single-node form of `53 → 48`. `$any$` on either side matches every index **and** the
 * empty cell (`specs/M6-A1` §5.3).
 */
import { z } from 'zod';
import { defineTrigger } from '../block.js';
import { columnRefSchema, labelIndexOf, labelValueMatches, labelValueSchema } from '../values.js';
export const statusChangesFromToParams = z.object({
    columnId: columnRefSchema,
    previousStatusColumnValue: labelValueSchema,
    statusColumnValue: labelValueSchema,
});
export const statusChangesFromToTrigger = defineTrigger({
    id: '223089',
    kind: 'trigger',
    app: 'monday',
    sentencePartial: 'When {status, columnId} changes from {something, previousStatusColumnValue} to {something, statusColumnValue}',
    paramsSchema: statusChangesFromToParams,
    requiredColumnTypes: ['status'],
    subscribes: ['cell.changed'],
    references: (params) => [{ kind: 'column', id: params.columnId.columnId, invalid: params.columnId.invalid }],
    matches(event, params) {
        if (event.payload.columnId !== params.columnId.columnId)
            return false;
        const next = labelIndexOf(event.payload.value);
        const previous = labelIndexOf(event.payload.previousValue);
        if (next === previous)
            return false;
        return (labelValueMatches(params.previousStatusColumnValue, previous) &&
            labelValueMatches(params.statusColumnValue, next));
    },
    outputs(event) {
        return {
            itemId: event.itemId,
            boardId: event.boardId,
            columnId: event.payload.columnId,
            columnValue: labelIndexOf(event.payload.value),
            prevStatusValue: labelIndexOf(event.payload.previousValue),
        };
    },
});
//# sourceMappingURL=223089.js.map